import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { spacing } from '@material-ui/system';
import { Grid as MuiGrid } from '@material-ui/core';

const Grid = styled(MuiGrid)(spacing);

export default Grid;
